import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fill-height bg_auth",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "d-flex justify-center mb-4" }
const _hoisted_3 = ["height", "width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { class: "login" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          class: "d-flex align-center justify-center fill-height",
          style: {"height":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "10",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                      src: "/img/bobbee_logo_3.png",
                      height: !_ctx.$vuetify.display.mobile ? '100vh' : '',
                      width: !_ctx.$vuetify.display.mobile ? '' : '200vw'
                    }, null, 8, _hoisted_3)
                  ]),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: "Votre adresse mail",
                        "hide-details": "auto",
                        readonly: "",
                        "model-value": _ctx.decryptedEmail,
                        density: "compact"
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: "Votre mot de passe",
                        type: _ctx.displayPassword ? 'text' : 'password',
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                        onKeyup: _withKeys(_ctx.firstConnexion, ["enter"]),
                        "append-inner-icon": _ctx.displayPassword ? '$oss-eye' : '$oss-eye-slash',
                        rules: _ctx.passwordRules,
                        "data-cy": "password",
                        density: "compact",
                        "onClick:appendInner": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayPassword = !_ctx.displayPassword))
                      }, null, 8, ["type", "modelValue", "onKeyup", "append-inner-icon", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: "Confirmez votre mot de passe",
                        type: _ctx.displayPassword ? 'text' : 'password',
                        modelValue: _ctx.confirmPassword,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                        onKeyup: _withKeys(_ctx.firstConnexion, ["enter"]),
                        "append-inner-icon": _ctx.displayPassword ? '$oss-eye' : '$oss-eye-slash',
                        error: _ctx.error.length > 0,
                        "error-messages": _ctx.error,
                        rules: _ctx.confirmPasswordRules,
                        "data-cy": "password",
                        density: "compact",
                        "onClick:appendInner": _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayPassword = !_ctx.displayPassword))
                      }, null, 8, ["type", "modelValue", "onKeyup", "append-inner-icon", "error", "error-messages", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_alert, {
                        type: "info",
                        variant: "outlined",
                        density: "compact",
                        color: "primary"
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode(" Votre mot de passe doit contenir au moins 6 caractères avec au moins une majuscule et un chiffre ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_primary, {
                        class: "rounded-lg",
                        block: "",
                        loading: _ctx.loading,
                        onClick: _ctx.firstConnexion,
                        "data-cy": "login",
                        disabled: 
                                    _ctx.password.length === 0 ||
                                    _ctx.confirmPassword.length === 0 ||
                                    _ctx.password !== _ctx.confirmPassword
                                ,
                        size: "large"
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" Valider ")
                        ])),
                        _: 1
                      }, 8, ["loading", "onClick", "disabled"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}